import { render, staticRenderFns } from "./LineaTiempoComponent.vue?vue&type=template&id=6b013ab4"
import script from "./LineaTiempoComponent.vue?vue&type=script&lang=js"
export * from "./LineaTiempoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports